import React from 'react';

const PrivacyPolicyToS = () => {
    return ( 
        <div style={{ height: "100vh" }}>
            <iframe
                src="/PrivacyPolicyToS.html"
                style={{ width: "100%", height: "100%", border: "none" }}
                title="Embedded HTML"
            ></iframe>
            </div>
    );
};

export default PrivacyPolicyToS;